/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import { replaceSelectionNameByMarketAndSpecialBetValue } from '@utils/utils'

export interface IMarketInfo {
  specialBetValue
  marketName: string
  selectionName: string
  hitState: BET_HIT_STATE
  outcomeRate: string
}

export interface UserPickMarketInfoProps {
  data: IMarketInfo
}

export const UserPickMarketInfo: React.FC<UserPickMarketInfoProps> = observer((props): React.ReactElement => {
  const { data } = props
  const {
    specialBetValue,
    marketName,
    selectionName,
    hitState,
    outcomeRate,
  } = data

  const convertSelectionName = replaceSelectionNameByMarketAndSpecialBetValue(
    selectionName,
    marketName,
    specialBetValue,
  )

  const hitStateClassName = ['circle']
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      hitStateClassName.push('success')
      break
    case BET_HIT_STATE.CANCEL:
      hitStateClassName.push('cancel')
      break
    case BET_HIT_STATE.FAIL:
      hitStateClassName.push('fail')
      break
  }

  return (
    <div className="select-box test">
      <div className="outcome">
        <span className="selection">{convertSelectionName}</span>
        <span className="outcome-rate">{outcomeRate}</span>
      </div>
      {marketName} <span className="rate">{specialBetValue}</span>
      <span className={hitStateClassName.join(' ')}/>
    </div>
  )
})
